import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollPosition } from '@as/cotopaxi';
import { ProductTypes } from '@as-react/common-types';
import { Divider, StackBlock } from '@yonderland/andes-react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useIsInViewport } from '../../../../hooks/useIsInViewport';
import { analyticsActions } from '../../../../redux/analytics/actions/AnalyticsActions.creators';
import { makeGetBasketClickAndCollectStoreIdState, makeGetBasketMappedProductsState, makeGetBasketPricingState, makeGetBasketTotalVoucherAmountState, } from '../../../../redux/basket/selectors/BasketSelector';
import { makeGetUserEmail } from '../../../../redux/session/selectors/SessionSelector';
import { ApplePayButton } from '../../../apple-pay-button/ApplePayButton';
export const ApplePayCTA = ({ deliveryStoreName }) => {
    const applePayButtonRef = useRef(null);
    const { isInViewport } = useIsInViewport(applePayButtonRef);
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [applePayAnalyticsSent, setApplePayAnalyticsSent] = useState(false);
    const [scrollPositionChanged, setScrollPositionChanged] = useState(false);
    const dispatch = useDispatch();
    const { totalBasketDiscountAmount, totalPriceSellBeforeDiscount, totalPriceSell, priceTotalBasket, priceDelivery } = useSelector(makeGetBasketPricingState());
    const totalVoucherAmount = useSelector(makeGetBasketTotalVoucherAmountState());
    const products = useSelector(makeGetBasketMappedProductsState());
    const userEmail = useSelector(makeGetUserEmail());
    const clickAndCollectStoreId = useSelector(makeGetBasketClickAndCollectStoreIdState());
    const onApplePayButtonClick = () => dispatch(analyticsActions.applePayClick());
    useEffect(() => {
        const analyticsData = { componentInfo: { componentName: 'apple pay', componentType: 'payment button' } };
        if (isInViewport && !applePayAnalyticsSent) {
            if (!scrollPositionChanged) {
                dispatch(analyticsActions.applePayButtonInitialInViewport(analyticsData));
            }
            else {
                dispatch(analyticsActions.applePayButtonImpression(analyticsData));
            }
            setApplePayAnalyticsSent(true);
        }
    }, [isInViewport, applePayAnalyticsSent]);
    useScrollPosition(() => setScrollPositionChanged(true), [scrollPositionChanged]);
    const hasAndOnlyDigitalProduct = products.every(p => p.productType === ProductTypes.E_VOUCHER);
    return (_jsxs(StackBlock, { gap: "2", children: [_jsx(Divider, { text: t('product.check.popup.or'), textProps: { color: 'neutral', variant: 'bodyS' } }), _jsx(ApplePayButton, { totalPrices: {
                    totalBasketDiscountAmount: totalBasketDiscountAmount && totalPriceSellBeforeDiscount ? totalBasketDiscountAmount.toString() : '0',
                    totalPriceSell: (totalPriceSellBeforeDiscount || totalPriceSell).toString(),
                    priceTotalBasket: priceTotalBasket.toString(),
                    priceDelivery: priceDelivery.toString(),
                }, totalVoucherAmount: totalVoucherAmount, onClick: onApplePayButtonClick, hasAndOnlyDigitalProduct: hasAndOnlyDigitalProduct, userEmail: userEmail, clickAndCollectStoreId: clickAndCollectStoreId, storeName: deliveryStoreName, innerRef: applePayButtonRef })] }));
};
